import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const AdkBidsTable = ({ bids, onRemove, onUpdate, onSort }) => {
    const rows = bids.map((bid, index) => <Row key={index} bid={bid} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('country')}>Country</th>
                    <th onClick={() => onSort('bid')}>Bid</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkBidsTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkBids/components/Table/index.js